// src/components/Attendance.js
import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
// import StudentAttendance from './StudentAttendance';
import { useGrade } from '../../../context/GradeContext';
// import Form from 'react-bootstrap/Form';
import DailyAttendanceModal from '../Modals/DailyAttendanceModal';
import { useARData } from '../../../context/AttendanceRecordContext';
import { filterStudentsByClass } from '../Utility/filterStudentsByClass';  // Make sure this import path is correct
// import AttendancePage from './AttendancePage';
import { Table, Card, Form } from "react-bootstrap";

const Attendance = () => {
    // for daily attendance modal
    const daModal = useRef();

    // get classes from database
    const { grade } = useGrade();

    // this is the attendance data context 
    const { arData, loadingAr } = useARData();
 
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedClass, setSelectedClass] = useState("");

    const selectOption = (e) => {
    setSelectedClass(e.target.value);
    }
    
      const daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);

      const currentYear = new Date().getFullYear();
    
      const getDayColor = (day) => {
        // const currentYear = new Date().getFullYear();
        const date = new Date(`${currentYear}-${selectedMonth}-${day}`);
        const dayOfWeek = date.getDay();
        if (dayOfWeek === 6) return "bg-warning"; // Saturday - Yellow
        if (dayOfWeek === 0) return "bg-primary text-white"; // Sunday - Blue
        return "";
      };
    
      const students = arData?.students || []; // Ensure it defaults to an empty array
    
      const filteredStudents = students.filter(
        (student) => student.class_admitted === selectedClass
      );

      //style for legend-box
      const legendBoxStyle = {
        width: "20px",
        height: "20px",
        borderRadius: "4px",
        display: "inline-block",
    };
    
    return (
        <>        
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-title flex-wrap">
                                <div className="input-group search-area mb-md-0 mb-3">
                                    <input type="text" className="form-control" placeholder="Search here..." />
                                    <span className="input-group-text">
                                        <Link to={"#"}>
                                            <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17.5605 15.4395L13.7527 11.6317C14.5395 10.446 15 9.02625 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C9.02625 15 10.446 14.5395 11.6317 13.7527L15.4395 17.5605C16.0245 18.1462 16.9755 18.1462 17.5605 17.5605C18.1462 16.9747 18.1462 16.0252 17.5605 15.4395V15.4395ZM2.25 7.5C2.25 4.605 4.605 2.25 7.5 2.25C10.395 2.25 12.75 4.605 12.75 7.5C12.75 10.395 10.395 12.75 7.5 12.75C4.605 12.75 2.25 10.395 2.25 7.5V7.5Z" fill="#01A3FF"/>
                                            </svg>
                                        </Link>
                                    </span>
                                </div>
                                <div className='d-flex'>
                                <div className="d-flex align-items-center gap-2">
                                    <Form.Select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
                                    <option value="">---Month---</option>
                                    <option value="01">January</option>
                                    <option value="02">February</option>
                                    <option value="03">March</option>
                                    <option value="04">April</option>
                                    <option value="05">May</option>
                                    <option value="06">June</option>
                                    <option value="07">July</option>
                                    <option value="08">August</option>
                                    <option value="09">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                    </Form.Select>
                                </div>
                                <span className='p-2'></span>
                                    <Form.Select size="sm" style={{width:'120px'}} value={selectedClass} onChange={selectOption}>
                                        {grade.map((item, index) => 
                                            <option value={item.class_options} key={index}>{item.class_label}</option>
                                        )}
                                    </Form.Select>
                                    <span className="p-2"></span>                                                                   
                                    <button type="button" className="btn btn-primary" onClick={() => daModal.current.openModal()}>
                                        + Daily Attendance
                                    </button>
                                    <span className='p-2'></span>
                                    <button className='btn btn-success'>
                                        Bulk Record
                                    </button>
                                </div>
                            </div>
                        </div>                
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="table-responsive full-data">
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    {/* <StudentAttendance data={filteredData} /> */}
                                    <div className="mb-3 d-flex align-items-center gap-3">
                                        <div className="d-flex align-items-center">
                                            <div style={{ ...legendBoxStyle, backgroundColor: "green" }}></div>
                                            <span className="ms-2">Present</span>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div style={{ ...legendBoxStyle, backgroundColor: "red" }}></div>
                                            <span className="ms-2">Absent</span>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div style={{ ...legendBoxStyle, backgroundColor: "yellow" }}></div>
                                            <span className="ms-2">Saturday</span>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <div style={{ ...legendBoxStyle, backgroundColor: "blue" }}></div>
                                            <span className="ms-2">Sunday</span>
                                        </div>
                                    </div>


                                    <div className="table-responsive">
                                        {loadingAr ? (
                                        <p>Loading attendance records...</p>
                                        ) : (
                                        <Table striped bordered hover className="text-center">
                                            <thead>
                                            <tr>
                                                <th>Student Name</th>
                                                {daysInMonth.map((day) => (
                                                <th key={day} className={getDayColor(day)}>{day}</th>
                                                ))}
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {/* {filteredStudents.map((student) => (
                                                <tr key={student.student_uid}>
                                                <td>{student.full_name}</td>
                                                {daysInMonth.map((day) => {
                                                    const attendanceRecord = student.attendance.find(
                                                    (att) =>
                                                        att.date.split("-")[1] === selectedMonth &&
                                                        parseInt(att.date.split("-")[2]) === day
                                                    );
                                                    let cellClass = getDayColor(day);
                                                    if (attendanceRecord) {
                                                    cellClass += attendanceRecord.status === "P" ? " bg-success text-white" : " bg-danger text-white";
                                                    }
                                                    return (
                                                    <td key={day} className={cellClass}>
                                                        {attendanceRecord ? attendanceRecord.status : "-"}
                                                    </td>
                                                    );
                                                })}
                                                </tr>
                                            ))} */}
                                                {filteredStudents.map((student) => (
                                                    <tr key={student.student_uid}>
                                                        <td>{student.full_name}</td>
                                                        {daysInMonth.map((day) => {
                                                            const date = new Date(`${currentYear}`, selectedMonth - 1, day); // Create a date object
                                                            const dayOfWeek = date.getDay(); // Get day of week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)

                                                            const attendanceRecord = student.attendance.find(
                                                                (att) =>
                                                                    att.date.split("-")[1] === selectedMonth &&
                                                                    parseInt(att.date.split("-")[2]) === day
                                                            );
                                                            let cellClass = getDayColor(day);
                                                            if (attendanceRecord) {
                                                                cellClass += attendanceRecord.status === "P" ? " bg-success text-white" : " bg-danger text-white";
                                                            }

                                                            // Check if day is Saturday (6) or Sunday (0)
                                                            const displayText = attendanceRecord 
                                                                ? attendanceRecord.status 
                                                                : dayOfWeek === 0 
                                                                ? "Sun" 
                                                                : dayOfWeek === 6 
                                                                ? "Sat" 
                                                                : "-";

                                                            return (
                                                                <td key={day} className={cellClass}>
                                                                    {displayText}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </Table>
                                        )}
                                    </div>
                                </div>
                            </div>  
                        </div>    
                    </div>    
                </div>    
            </div>   
            <DailyAttendanceModal ref={daModal} />
            <br />
        </>
    )
}

export default Attendance;
